package chand.wordvoyage

import androidx.compose.runtime.Composable
import androidx.compose.ui.tooling.preview.Preview
import chand.wordvoyage.navigation.AppNavigation
import chand.wordvoyage.ui.WordVoyageTheme

@Composable
@Preview
fun App() {
    WordVoyageTheme {
        AppNavigation()
    }
}
